import { createServerFn } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

export const triggerLevantaSync = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => {
    const { supabase, userId } = context;
    const { data: isAdmin } = await supabase.rpc("has_role", {
      _user_id: userId,
      _role: "admin",
    });
    if (!isAdmin) throw new Error("Forbidden: admin role required");
    const { runLevantaSync } = await import("./levanta-sync.server");
    return runLevantaSync();
  });

export const triggerAmazonSync = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => {
    const { data: isAdmin } = await context.supabase.rpc("has_role", { _user_id: context.userId, _role: "admin" });
    if (!isAdmin) throw new Error("Forbidden");
    const { runAmazonSync } = await import("./amazon-sync.server");
    return runAmazonSync();
  });

export const triggerImpactSync = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => {
    const { data: isAdmin } = await context.supabase.rpc("has_role", { _user_id: context.userId, _role: "admin" });
    if (!isAdmin) throw new Error("Forbidden");
    const { runImpactSync } = await import("./impact-sync.server");
    return runImpactSync();
  });

export const reindexAlgolia = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => {
    const { data: isAdmin } = await context.supabase.rpc("has_role", { _user_id: context.userId, _role: "admin" });
    if (!isAdmin) throw new Error("Forbidden");
    const { runAlgoliaReindex } = await import("./algolia-reindex.server");
    return runAlgoliaReindex();
  });

const VALID_REASONS = ["out_of_stock", "wrong_price", "broken_link", "inappropriate", "other"] as const;
type ReportReason = (typeof VALID_REASONS)[number];

export const submitProductReport = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((input: { productId: string; reason: ReportReason; notes?: string }) => {
    if (!input.productId || typeof input.productId !== "string") throw new Error("productId required");
    if (!VALID_REASONS.includes(input.reason)) throw new Error("Invalid reason");
    const notes = (input.notes ?? "").toString().slice(0, 1000);
    return { productId: input.productId, reason: input.reason, notes };
  })
  .handler(async ({ data, context }) => {
    const { error } = await context.supabase.from("product_reports").insert({
      product_id: data.productId,
      reporter_id: context.userId,
      reason: data.reason,
      notes: data.notes || null,
    });
    if (error) throw new Error(error.message);
    return { ok: true };
  });
